import Head from 'next/head'

import config from '@/config/index'

const GlobalMetadata = () => {
  const themeColor = '#68d07f'
  const backgroundColor = '#2A2C3C'

  return (
    <Head>
      {/* Basic metadata */}
      <meta charSet="utf-8" />
      {/* Ensures proper rendering and touch zooming for all devices */}
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      {/* Web App Manifest for PWA */}
      <link rel="manifest" href="/manifest.json" />

      {/* PWA primary color */}
      <meta name="theme-color" content={themeColor} />

      {/* Microsoft Tile Color */}
      <meta name="msapplication-TileColor" content={backgroundColor} />
      <meta name="msapplication-tap-highlight" content="no" />

      {/* Favicon */}
      {config.environment === 'dev' ? (
        <link rel="icon" href="/favicon-dev.ico" />
      ) : (
        <link rel="icon" href="/favicon.ico" />
      )}

      {/* iOS home screen icon */}
      <link rel="apple-touch-icon" href="/icons/96x96.png" />

      {/* iOS web app capable */}
      <meta name="apple-mobile-web-app-capable" content="yes" />

      {/* iOS web app title */}
      <meta name="apple-mobile-web-app-title" content="BuildPass - Admin" />

      {/* Application name */}
      <meta name="application-name" content="BuildPass" />

      {/* Description for search engines */}
      <meta
        name="description"
        content="Streamline your construction projects with BuildPass"
      />

      {/* Theme color for browser UI */}
      <meta name="theme-color" content="#FFFFFF" />

      {/* TODO: Can remove these once they are being set correctly on individual pages */}
      {/* Open Graph / Facebook metadata */}
      {/* Specifies that this is a website */}
      <meta property="og:type" content="website" />
      {/* The canonical URL of your site */}
      <meta property="og:url" content="https://buildpass.com.au/" />
      {/* The title of your site for social sharing */}
      <meta property="og:title" content="BuildPass - Construction Management" />
      {/* The description of your site for social sharing */}
      <meta
        property="og:description"
        content="Streamline your construction projects with BuildPass"
      />
      {/* The image to display when your site is shared on social media */}
      <meta
        property="og:image"
        content="https://app.buildpass.com.au/icons/512x512.png"
      />

      {/* Twitter Card metadata */}
      {/* Specifies the card type, here it's a large image card */}
      <meta property="twitter:card" content="summary_large_image" />
      {/* The URL of your site */}
      <meta property="twitter:url" content="https://buildpass.com.au/" />
      {/* The title of your site for Twitter sharing */}
      <meta
        property="twitter:title"
        content="BuildPass - Construction Management"
      />
      {/* The description of your site for Twitter sharing */}
      <meta
        property="twitter:description"
        content="Streamline your construction projects with BuildPass"
      />
      {/* The image to display when your site is shared on Twitter */}
      <meta
        property="twitter:image"
        // todo - find image to use
        content="https://app.buildpass.com.au/icons/512x512.png"
      />

      <link
        rel="apple-touch-startup-image"
        href="/icons/384x384.png"
        media="(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
      />
      <link
        rel="apple-touch-startup-image"
        href="/icons/384x384.png"
        media="(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
      />
      <link
        rel="apple-touch-startup-image"
        href="/icons/512x512.png"
        media="(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
      />
      <link
        rel="apple-touch-startup-image"
        href="/icons/512x512.png"
        media="(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
      />
      <link
        rel="apple-touch-startup-image"
        href="/icons/512x512.png"
        media="(min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
      />
      <link
        rel="apple-touch-startup-image"
        href="/icons/512x512.png"
        media="(min-device-width: 834px) and (max-device-width: 834px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
      />
      <link
        rel="apple-touch-startup-image"
        href="/icons/512x512.png"
        media="(min-device-width: 1024px) and (max-device-width: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
      />
    </Head>
  )
}

export default GlobalMetadata
